module.exports = "/_next/static/images/f23fa3eabbd303c6baa1e544cdf2dab7.jpg";